import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

const OLD_API = 'https://goodgame.ru/api/player?src=';

@Injectable()
export class ApiService {
  constructor(private http: HttpClient) {

  }

  public getOldApi(src: string) {
    return this.http.get(OLD_API + src, {/*withCredentials: true*/});
  }
}
